<template>
  <div class="courseChoice">
    <div class="background"></div>
    <div class="pickModule">
      <h2>{{ t("title") }}</h2>
      <div class="choices">
        <div
          class="choice"
          v-for="(course, index) in courses"
          :key="course.name"
          :id="'choice' + index"
        >
          <div v-if="index == 0">
            <router-link class="link" :to="{ name: 'test-choice', params: { id: course.id } }">
              <img class="moduleImage" :src="getImage(course.pictureLink)" :alt="course.name">
              <h3>{{ course.name }}</h3>
            </router-link>
          </div>
          <div v-if="index == 1">
            <router-link class="link" :to="{ name: 'test-choice', params: { id: course.id } }">
              <img class="moduleImage" :src="getImage(course.pictureLink)" :alt="course.name">
              <h3>{{ course.name }}</h3>
            </router-link>
          </div>
          <div v-if="index == 2">
            <router-link class="disabled" :to="{ name: 'notFound' }">
              <img class="moduleImage" :src="getImage(course.pictureLink)" :alt="course.name">
              <h3>{{ course.name }}</h3>
            </router-link>
          </div>
          <div v-if="index == 3">
            <router-link class="disabled" :to="{ name: 'notFound' }">
              <img class="moduleImage" :src="getImage(course.pictureLink)" :alt="course.name">
              <h3>{{ course.name }}</h3>
            </router-link>
          </div>
        </div>
      </div>
      <button class="signOutButton" @click="logOut">
        <h4>{{ t("logOut") }}</h4>
      </button>
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
export default {
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "local"
    });
    return { t };
  },

  name: "CoursesChoice",
  components: {},

  created() {
    this.$store.dispatch("fetchCourses");
    this.$store.dispatch("resetTestChoice");
  },

  computed: {
    courses() {
      return this.$store.state.courses;
    }
  },
  methods: {
    logOut() {
      this.$store.dispatch("logOut");
      this.$router.replace({ name: "home" });
    },
    getImage(image) {
      return `https://phoenix-engineering-images.ams3.digitaloceanspaces.com/${image}`;
    }
  }
};
</script>

<i18n>
{
  "en-GB": {
    "title": "CHOOSE THE COURSE YOU ARE FOLLOWING",
    "logOut":"Sign out"
  },
  "nl-NL": {
    "title": "Kies de module die u momenteel volgt",
    "logOut":"Afmelden"
  }
}

</i18n>

<style  scoped>
.courseChoice {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.background {
  background-image: url("https://phoenix-engineering.be/wp-content/uploads/2019/07/shutterstock_1113165392.png");
  background-size: cover;
  background-position: unset;
  background-repeat: no-repeat;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  filter: blur(3px);
  -webkit-filter: blur(3px);
  z-index: -1;
}

.pickModule {
  background-color: rgb(163, 163, 163);
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 1200px;
  position: relative;
  box-shadow: 0px 3px 20px rgb(89, 102, 100);
  opacity: 0.95;
}

h2 {
  font-size: 35px;
  letter-spacing: 2px;
  margin: 0px;
  background-color: rgb(41, 41, 42);
  padding-bottom: 40px;
  padding-top: 40px;
  color: white;
  width: 100%;
}

.link {
  text-decoration: none;
}

.pickModule h3 {
  font-size: 14px;
  font-weight: 100;
  text-transform: uppercase;
  max-width: 100%;
  margin: 0px;
  background-color: rgb(41, 41, 42);
  padding: 11px;
  color: white;
}

.choice {
  display: inline-flex;
  margin: 70px;

  cursor: pointer;
  box-shadow: 0px 3px 10px black;
  padding-bottom: 0px;

  border-style: solid;
  border-color: rgb(62, 62, 62);
  border-bottom: 5px solid rgb(62, 62, 62);

  opacity: 1;
}

#choice2,
#choice3 {
  margin-top: 0px;
  margin-bottom: 20px;
}

.moduleImage {
  width: 285px;
  height: 190px;
  opacity: 0.8;
  margin-top: 0px;
  margin-bottom: -5px;
}
.choice:hover {
  transform: scale(1.05);
}
.link:hover > .moduleImage {
  opacity: 1;
}

.disabled {
  opacity: 0.1;
  pointer-events: none;
}

.signOutButton {
  font-family: "Raleway", sans-serif;
  background-color: rgb(41, 41, 42);
  box-shadow: 0 0px 5px 0px rgb(89, 102, 100);
  color: rgb(255, 255, 255);
  border-style: none;

  cursor: pointer;

  margin: 30px;
  padding: 20px 30px;
}
.signOutButton:hover {
  transform: scale(1.04);
}

h4 {
  font-size: 18px;
  font-weight: 100;
  text-transform: uppercase;
  margin: 0px;
}

/* -------------------------------------------------------------------------------------------------------------------------------------------------------------------- */

@media screen and (max-width: 1300px) {
  .pickModule {
    width: 1000px;
  }

  h2 {
    font-size: 30px;
    padding-bottom: 30px;
    padding-top: 30px;
  }

  .pickModule h3 {
    font-size: 12px;
    letter-spacing: 1.5px;
  }

  .choice {
    border-bottom: 4px solid rgb(62, 62, 62);
    margin: 60px;
  }

  .moduleImage {
    width: 270px;
    height: 180px;
  }

  button {
    margin: 30px;
    padding: 18px 25px;
  }

  h4 {
    font-size: 13px;
    letter-spacing: 1.5px;
  }
}
@media screen and (max-width: 1100px) {
  .pickModule {
    width: 850px;
  }

  h2 {
    font-size: 28px;
    padding-bottom: 30px;
    padding-top: 30px;
  }

  .pickModule h3 {
    font-size: 11px;
    letter-spacing: 1.5px;
  }

  .choice {
    margin: 50px;
  }

  .moduleImage {
    width: 255px;
    height: 170px;
  }

  button {
    margin: 30px;
    padding: 15px 20px;
  }

  h4 {
    font-size: 11px;
    letter-spacing: 1.5px;
  }
}
@media screen and (max-width: 900px) {
  .pickModule {
    width: 750px;
  }

  h2 {
    font-size: 26px;
  }

  .choice {
    margin: 50px;
    border-bottom: 2px solid rgb(62, 62, 62);
    width: 235px;
  }
  #choice2,
  #choice3 {
    margin-top: 0px;
    margin-bottom: 10px;
  }

  .pickModule h3 {
    font-size: 11px;
  }
  .moduleImage {
    width: 235px;
    height: 157px;
  }

  button {
    margin: 30px;
    padding: 15px 20px;
  }

  h4 {
    font-size: 11px;
    letter-spacing: 1px;
  }
}

@media screen and (max-width: 780px) {
  .pickModule {
    margin-top: 30px;
    margin-bottom: 30px;
    width: 500px;
  }

  h2 {
    font-size: 22px;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .choice {
    margin-top: 50px;
    margin-bottom: 0px;
  }
  #choice2,
  #choice3 {
    margin-top: 50px;
    margin-bottom: 0px;
  }
  button {
    margin-top: 50px;
  }
}

@media screen and (max-width: 450px) {
  .pickModule {
    width: 350px;
  }
  h2 {
    font-size: 20px;
  }
}
</style>


